// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b88e696e","513":"3dbb05e2","703":"fe923c1b","787":"ce70d374"}[chunkId] + ".chunk.js";
};